<template>
  <!-- 提交 -->
  <div class="Submit">
    <div v-if="!data.answered">
      <!-- 这是题目的标题一类的 -->
      <div class="Submit_title">
        <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
        <span class="span" v-if="data.rule?data.rule.length:false">上传文件数量不得超过{{data.rule.length}}个<span class="span subTitle" v-if="data.rule.subTitle && JSON.stringify(data.rule.subTitle).trim() != ''">，{{data.rule.subTitle}}</span></span>
      </div>
      <!-- 题目描述 -->
      <div class="text" v-for="o in data.questionDes?JSON.parse(data.questionDes):[]" :key="JSON.stringify(o)" v-text="o.txt">
      </div>
      <!-- 这是上传文件的部分 -->
      <div class="clear">
        <div class="Submit_box fl" v-for="(item,index) in list" :key="index">
          <div class="img_box img_file blpc">
            <img src="../../../../assets/img/icon/file.png">
          </div>
          <div class="title" :title="item.name">{{item.file.name?item.file.name:item.fileName}}</div>
          <div class="progress" v-show="item.bol">{{item.progress}}%</div>
          <div class="blpc del cursor" @click="del(index)" v-if="item.fileId">&#xe6cb;</div>
          <div class="schedule" v-show="item.bol">
            <div class="schedule_point" :style="{width:item.progress+'%'}"></div>
          </div>
        </div>
        <!-- 上传文件的那个框 -->
        <div class="fl">
          <label :for="'label'+data.questionId" id="label" class="fl" v-if="list.length<(data.rule?(data.rule.length||999):999)">
            <div class="Submit_box cursor">
              <div class="img_box blpc">
                &#xe6dc;
              </div>
              <div class="title">*格式：{{format.length==0?'pdf、doc、docx...':format.join('、')}}</div>
            </div>
          </label>
          <input type="file" :ref="'label'+data.questionId" :accept="fileAccept.toString()" @change="upload" class="none" :id="'label'+data.questionId">
        </div>
      </div>
      <!-- 这是下载模板 -->
      <div class="download" @click="downloadFn(item.templateNaUrl)" v-for="(item,index) in data.rule?(data.rule.templateMap||[]):[]" :key="index">
        {{item.templateName}}
      </div>
    </div>
    <!-- 提交答案后 -->
    <div v-else>
      <div class="Submit_title">
        <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
        <span class="span" v-if="data.rule?data.rule.length:false">（上传文件数量不得超过{{data.rule.length}}个，<span class="span subTitle" v-if="data.rule">{{data.rule.subTitle}}</span>）</span>
      </div>
      <div class="text" v-for="o in data.questionDes?JSON.parse(data.questionDes):[]" :key="JSON.stringify(o)" v-text="o.txt">
      </div>
      <div class="clear">
      <div class="Submit_box fl" v-for="(item,index) in list" :key="index">
          <div class="img_box img_file blpc">
            <img src="../../../../assets/img/icon/file.png">
          </div>
          <div class="title" :title="item.name">{{item.file?item.file.name:item.fileName}}</div>
          <div class="showOrDownBox" v-if="item && !item.bol">
            <img class="show" src="https://img.webloom.cn/img/showFile.png" v-if="showFileIcon(item)" @click="showPDF(item)" alt="">
            <img class="show down" src="https://img.webloom.cn/img/downFile.png" @click="downFile(item)" alt="" srcset="">
          </div>
          <div class="progress" v-show="item.bol">{{item.progress}}%</div>
          <div class="blpc del cursor" @click="del(index)" v-if="item.fileId && !disabledBol">&#xe6cb;</div>
          <div class="schedule" v-show="item.bol">
            <div class="schedule_point" :style="{width:item.progress+'%'}"></div>
          </div>
        </div>
        <div class="fl" v-if="!disabledBol">
          <label :for="'label'+data.questionId" id='label' class="fl" v-if="list.length<(data.rule.length||999)">
            <div class="Submit_box cursor">
              <div class="img_box blpc">
                &#xe6dc;
              </div>
              <div class="title">*格式：{{format.length==0?'pdf、doc、docx...':format.join('、')}}</div>
            </div>
          </label>
          <input type="file" :ref="'label'+data.questionId" :accept="fileAccept.toString()" @change="upload" class="none" :id="'label'+data.questionId">
        </div>
      </div>
      <!-- 这是下载模板 -->
      <div class="download" @click="downloadFn(item.templateNaUrl)" v-for="(item,index) in data.rule?(data.rule.templateMap||[]):[]" :key="index">
        {{item.templateName}}
      </div>
    </div>
    <!-- 答案隐藏文字id -->
    <div class="answerObj none">{{answerObj}}</div>
    <div class="isNecessary none">{{data.rule ? (data.rule.isNecessary ? 1 : 0) : 0}}</div>
    <el-dialog
      :append-to-body="true"
      title="预览图片"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="()=>{dialogVisible = false}">
      <img style="width:100%" :src="dialogImg" alt="" srcset="">
    </el-dialog>
  </div>
</template>

<script>

import fileConstant from '@assets/js/constant.js'
import putFile from '@assets/api/js/ali-oss'

export default {
  name: 'Submit',
  props: {
    data: Object,
    disabledBol: Boolean
  },
  computed: {
    // 答案
    answerObj () {
      // 纯在的已经上传完文件数量
      let arr = []
      let obj
      for (let i in this.list) {
        if (this.list[i].bol) {
          obj = {
            msg: '请等待文件上传成功后提交'
          }
          break
        } else {
          arr.push(this.list[i].fileId)
        }
      }
      if (this.list.length === 0) {
        obj = {
          msg: '请选择文件后提交'
        }
      // 当没有正在上传文件时才可以提交文件上传
      } else if (this.list.length === arr.length) {
        obj = {
          questionId: this.data.questionId,
          item: arr.join('|')
        }
      }
      return obj
    },
    // 过滤文件属性
    fileAccept () {
      let arr = []
      for (let i in this.format) {
        let val = this.format[i]
        arr.push(this.accept[val])
      }
      return arr
    }
  },
  data () {
    return {
      dialogVisible: false,
      dialogImg: '',
      list: [],                            // 上传列表
      loading: false,                      // 上传动画
      // format: ['pdf', 'doc', 'docx'],
      format: [],
      accept: fileConstant['fileAccept']
    }
  },
  methods: {
    showFileIcon(item){
      if(!item) return
      let name = item && item.file && item.file.name ? item.file.name : item.fileName
      let list = ['.pdf','.png','.jpg','jpeg','.mp4','.mov']
      return list.filter(res=>{
        return name.indexOf(res) > -1
      }).length > 0
    },
    showPDF(item){
      let name = item && item.file && item.file.name ? item.file.name : item.fileName
      let list = ['.png','.jpg','jpeg']
      let res = list.filter(res=>{
        return name.indexOf(res) > -1
      })
      if (res.length > 0) {
        this.dialogImg = item.url
        this.dialogVisible = true
      } else window.open(item.url)
    },
    downFile(item){
      let url =  window.location.origin + '/api/file/downLoad?id=' + item.fileId
      let a = document.createElement('a')
      a.download = item.fileName
      a.href = url
      a.target = '_blank'
      a.click()
    },
    // 下载
    downloadFn (url) {
      window.open(url)
    },
    // 上传
    upload () {
      let file = this.$refs[`label${this.data.questionId}`].files[0]
      // console.log(this.$refs.file.files[0])
      // 判断文件格式是否正确
      if (this.format.length !== 0) {
        let typeStr = file.type
        let foo = false
        this.format.forEach(item => {
          if (typeStr === this.accept[item]) {
            foo = true
          }
        })
        if (!foo) {
          let str = this.format.join('、')
          this.$message.error(`请上传${str}格式的文件`)
          return
        }
      }

      if (!this.$refs[`label${this.data.questionId}`].files[0]) {
        return
      }
      let fileKey = new Date().getTime()
      let fileObj = {
        bol: true,            // 是否在上传
        fileKey,
        progress: 0,
        file: file,
        fileId: 0
      }
      const progress = async (percentage) => {
        fileObj.progress = Math.floor(percentage * 100)
      }
      this.list.push(fileObj)
      file.dir = 'work/'
      putFile('multipartUpload', file, progress).then(res => {
        fileObj.fileId = res.res.fileId || 0
        fileObj.bol = false
        this.$message.success(file.name + '上传成功')
        this.$refs[`label${this.data.questionId}`].value = ''
      }).catch(() => {
        this.$message.error(file.name + '上传失败，请重新上传')
        for (let i in this.list) {
          if (this.list[i].fileKey === fileKey) {
            this.list.splice(i, 1)
          }
        }
        this.$refs[`label${this.data.questionId}`].value = ''
      })
      // let form = new FormData()
      // form.append('file', file)
      // // form.append('fileType', 'image')
      // form.append('businessType', file.type)
      // this.$api.file('FILE_UPLOAD', form, (res) => {
      //   this.loading = false
      //   file.fileId = res.data.fileId
      //   this.list.push(file)
      // }, () => {
      //   this.loading = false
      // }, () => {
      //   this.loading = false
      // })
    },
    // 删除文件
    del (index) {
      this.$refs[`label${this.data.questionId}`].value = null
      
      this.list.splice(index, 1)
    },
    // 初始化
    init () {
      if (this.data.answered) {
        this.list = this.data.files
      }
      // 文件格式
      if (this.data.rule) {
        if (this.data.rule.format) {
          this.data.rule.format = this.data.rule.format.replace(/\|/g, ',')
          this.format = this.data.rule.format.split(',')
        }
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body{
  padding-top: 0;
}
/deep/ .el-dialog{
  width: 40% !important;
  position: absolute;
  top:50%;
  left: 50%;
  transform: translate(-50%,-50%);
  margin-top: 0 !important;
  border-radius: 12px;
}
/deep/ .el-dialog__body{
  margin-bottom: 24px;
  padding-bottom: 0;
  box-sizing: border-box;
  max-height: 70vh;
  overflow: hidden;
  overflow-y: scroll;
}
.Submit{
  .Submit_title{
    color: #303133;
    font-size: 16px;
    margin-top: 24px;
    .span{
      color: #909399;
      font-size: 12px;
    }
  }
  .text{
    margin-top: 8px;
    color: #606266;
    font-size: 12px;
    line-height: 20px;
    word-break: break-word;
    white-space: pre-wrap;
  }
  .Submit_box:nth-of-type(2n-1) {
    margin-right: 32px;
  }
  #label>.Submit_box{
    margin-right: 0;
  }
  .Submit_box{
    width: 336px;
    height: 72px;
    background-color: #f4f4f4;
    border-radius: 4px;
    display: flex;
    margin-top: 8px;
    position: relative;
    .showOrDownBox{
      display: flex;
      justify-content: center;
      align-items: center;
      .show{
        cursor: pointer;
        width: 18px;
        height: 18px;
        margin-right: 11px;
      }
      .down{
        margin-right: 14px;
      }
    }
    .del{
      position: absolute;
      top: -10px;
      right: -10px;
      font-size: 20px;
      color: #F56C6C;
    }
    .img_box{
      width: 40px;
      height: 40px;
      margin: 16px;
      box-sizing: border-box;
      border: 1px dashed #D6D6D6;
      border-radius: 2px;
      line-height: 40px;
      text-align: center;
      color: #D6D6D6;
    }
    .img_file{
      border: none;
      img{
        margin-top: 3px;
      }
    }
    .title{
      line-height: 72px;
      width: 200px;
      color: #8F8F8F;
      font-size: 12px;
      padding-right: 16px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .progress{
      line-height: 72px;
      color: #296BFF;
      font-size: 12px;
    }
    .schedule{
      position: absolute;
      left: 0;
      width: 100%;
      height: 3px;
      background: #E2E2E2;
      bottom: 0px;
      .schedule_point{
        height: 100%;
        background-color: #296BFF;
      }
    }
  }
  .download{
    color: #296BFF;
    cursor: pointer;
    margin-top: 16px;
    // display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/topic/public/submit.vue